module.exports = __webpack_public_path__ + "img/sendemail.b37d0436.svg";